export default class AddressHelper {
  public static isValidSpainPostCode(zipCode: string): boolean {
    return zipCode.substr(0, 2) !== `38` && zipCode.substr(0, 2) !== `35` && zipCode.length === 5;
  }

  public static isValidCanaryIslandPostCode(zipCode: string): boolean {
    return (zipCode.substr(0, 2) === `38` || zipCode.substr(0, 2) === `35`) && zipCode.length === 5;
  }
}
